import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { ToastSettings } from "../../../utils/ToastSettings";
import { ArticleLockService } from "../../../services/Articles/ArticlesLocks/ArticleLockService";
import { useAuth } from "../../AuthProvider";

interface ContextProps {
    articleLock: any,
    setArticleLock: Dispatch<SetStateAction<any>>,
    isLoading: boolean,
    error: string,
    setError: Dispatch<SetStateAction<string>>,
    handleFetch: (data: any) => Promise<boolean>,
    handleGet: (articleId: number) => Promise<boolean>,
}

export const ArticleLockContext = createContext<ContextProps>({} as ContextProps);

interface ArticleLockProviderProps {
    children: ReactNode;
}

export const ArticleLockProvider = ({ children }: ArticleLockProviderProps) => {
    const [articleLock, setArticleLock] = useState<any>({} as any);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [error, setError] = useState<string>('');

    const service = new ArticleLockService();
    const { userLogged } = useAuth();

    const handleFetch = async (data: any) => {
        try {
            const [_Response, _Error, _Code, _Errors] = await service.fetch(data);
            if (!!_Error) {
                ToastSettings(_Response?.message || _Error, 'bottom-center', 'error', () => { }, _Errors);
                return false;
            }

            setError('');
            return true;
        } catch (e) {
            setError('Houve um erro ao salvar o bloqueio da edição do artigo');
            return false;
        }
    }

    const handleGet = async (articleId: number) => {
        try {
            const [_Response, _Error, _Code, _Errors] = await service.get(articleId);

            if (!!_Error) {
                ToastSettings(_Response?.message || _Error, 'bottom-center', 'error', () => { }, _Errors);
                return false;
            }

            setArticleLock(_Response);
            setError('');
            return (!!_Response?.data && _Response?.data?.user_id !== userLogged?.id) ? true : false;
        } catch (e) {
            setError('Houve um erro ao buscar o bloqueio da edição do artigo');
            return false;
        }
    }

    useEffect(() => {
        !!error && toast.error(error);
    }, [error]);

    return (
        <ArticleLockContext.Provider value={{
            articleLock,
            setArticleLock,
            isLoading,
            error,
            setError,
            handleFetch,
            handleGet,
        }}>
            {children}
        </ArticleLockContext.Provider>
    );
}

export const useArticleLock = () => useContext(ArticleLockContext);